import { render, staticRenderFns } from "./platform-settlement-panel.vue?vue&type=template&id=cda84d0c&scoped=true"
import script from "./platform-settlement-panel.vue?vue&type=script&lang=js"
export * from "./platform-settlement-panel.vue?vue&type=script&lang=js"
import style0 from "./platform-settlement-panel.vue?vue&type=style&index=0&id=cda84d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda84d0c",
  null
  
)

export default component.exports